import { useEffect, useState } from 'react';
import { getAppConfig } from '../services/AppConfigService';

/** Sent by the Configuration tab after a change: the tab row reads the signal again. */
export const APP_CONFIG_CHANGED_EVENT = 'flow:app-config-changed';

export function notifyAppConfigChanged(projectId) {
  if (typeof window !== 'undefined') { window.dispatchEvent(new CustomEvent(APP_CONFIG_CHANGED_EVENT, { detail: { projectId } })); }
}

/**
 * How many secrets the project's services declare but nobody set yet (the Configuration tab's Auto reason): read once
 * per project and again on APP_CONFIG_CHANGED_EVENT. Any failure (an older sandbox, no vfs-service) is 0.
 */
export default function useAppConfigSignal(projectId) {
  const [missing, setMissing] = useState(0);
  useEffect(() => {
    if (!projectId) { setMissing(0); return undefined; }
    let live = true;
    const read = () => getAppConfig(projectId)
      .then((answer) => { if (live) { setMissing((answer.services || []).reduce((n, s) => n + (s.secretsMissing?.length || 0), 0)); } })
      .catch(() => { if (live) { setMissing(0); } });
    read();
    const onChange = (event) => { if (!event.detail?.projectId || event.detail.projectId === projectId) { read(); } };
    window.addEventListener(APP_CONFIG_CHANGED_EVENT, onChange);
    return () => { live = false; window.removeEventListener(APP_CONFIG_CHANGED_EVENT, onChange); };
  }, [projectId]);
  return missing;
}
